import toastr from "toastr";
import { bannerDisplayPolygonList } from "./bannerDisplayPolygonData.js";
const nurseryMap = {
    map: null,
    isPickupNursery: false,
    googleInit: false,
    positionInit: false,
    distanceMode: "home",
    referenceLatitude: null,
    referenceLongitude: null,
    geocodeLatitude: null,
    geocodeLongitude: null,
    markerMap: new Map(),
    geocodeResult: null,
    isLoading: false,
    isBannerDisplayed: false,

    // 初期化関係
    // googleからの通知
    initGoogle: function () {
        nurseryMap.googleInit = true;
        nurseryMap.initMap();
    },

    //基準位置情報取得の通知
    //これはGPSが初期化したら呼び出される。
    initReferencePosition: function () {
        nurseryMap.positionInit = true;
        nurseryMap.initMap();
    },

    // 2つの初期化が実行されないと地図は初期化されない
    initMap: function () {
        if (!nurseryMap.positionInit || !nurseryMap.googleInit) {
            return;
        }

        // デフォルト東京駅で初期化
        let center = {
            lat: 35.6809591,
            lng: 139.7673068
        };

        // 規定位置が設定されているなら、それを使う。
        if (distance.referenceLatitude && distance.referenceLongitude) {
            center = {
                lat: distance.referenceLatitude,
                lng: distance.referenceLongitude
            };
        }

        // 初期化時にキーワード指定がされているなら、そこを中心にする。
        if (nurseryMap.geocodeLatitude && nurseryMap.geocodeLongitude) {
            center = {
                lat: nurseryMap.geocodeLatitude,
                lng: nurseryMap.geocodeLongitude
            };
        }

        // もし、パラメータに緯度経度が指定してあったら移動
        const centerLatitude = $(".js-currentCenterLatitudeLongitude").data("latitude");
        const centerLongitude = $(".js-currentCenterLatitudeLongitude").data("longitude");
        if (centerLatitude && centerLongitude) {
            center = {
                lat: centerLatitude,
                lng: centerLongitude
            };
        }

        // 地図本体の初期化
        const map = document.getElementById("map");
        nurseryMap.map = new google.maps.Map(map, {
            center: center,
            zoom: 15,
            mapTypeControl: false,
            cameraControl: false,
            zoomControl: false,
            fullscreenControl: false,
            streetViewControl: false,
            clickableIcons: false,
            styles: [
                {
                    featureType: "poi",
                    stylers: [{ visibility: "off" }]
                }
            ]
        });

        // その他の情報も初期化
        // 移動時にピンの再読み込み設定
        google.maps.event.addListener(nurseryMap.map, "idle", function () {
            nurseryMap.mapLoading();
        });

        // キーワードが設定されているか確認して移動。
        const searchValue = $("#search").val();
        if (searchValue !== "") {
            // 何か入っているならジオコード実行後に初期化完了
            nurseryMap.codeAddress(searchValue);
        } else {
            $(map).show();
        }
    },
    // 地図の再読み込み時の調整
    mapLoading: function () {
        const centerPosition = nurseryMap.map.getCenter();
        const centerLatitude = centerPosition.lat();
        const centerLongitude = centerPosition.lng();

        const paramList = new FormData();
        paramList.append("centerLatitude", centerLatitude);
        paramList.append("centerLongitude", centerLongitude);

        // 条件取得してマージ
        const searchConditionString = searchCondition.getSearchParamList();

        post.postAjaxData(
            "/parent/ajaxMap/" + searchConditionString,
            paramList,
            "",
            nurseryMap.mapMoveDone,
            null,
            null
        );

        for (const bannerDisplayPolygon of bannerDisplayPolygonList) {
            // マップの中心地点の緯度経度が特定の市内 の場合にバナー表示
            if (nurseryMap.isPointInside(bannerDisplayPolygon.area)) {
                nurseryMap.displayBanner(bannerDisplayPolygon["article-url"], bannerDisplayPolygon["banner-img-url"]);
                break;
            }
        }
    },
    // 移動読み込み完了時のコード
    mapMoveDone: function (results) {
        // マーカークリックではない場合は施設コンテナを非表示にする
        if (!nurseryMap.isPickupNursery) {
            $(".js-nursery-pickup").hide();
        }
        // デフォルトに戻す
        nurseryMap.isPickupNursery = false;

        // 成功したときのコールバック
        // 施設配列の順番を保持するため、MAPオブジェクトに詰める
        for (const nurseryObject of results["searchResultNurseryViewModelList"]) {
            if (nurseryMap.markerMap.get(nurseryObject["nurseryId"]) === undefined) {
                nurseryMap.markerMap.set(nurseryObject["nurseryId"], {
                    lat: parseFloat(nurseryObject["latitude"]),
                    lng: parseFloat(nurseryObject["longitude"]),
                    nurseryId: nurseryObject["nurseryId"],
                    mapPinImage: nurseryObject["mapPinImage"],
                    mapClickPinImage: nurseryObject["mapClickPinImage"],
                    isRecommended: nurseryObject["isRecommended"]
                });
            }
        }

        //削除対象のピン一覧を探すため、施設IDだけの配列を生成する
        const resultKeyList = results["searchResultNurseryViewModelList"].map((item) => {
            return item["nurseryId"];
        });

        // 削除対象のピン一覧を生成
        for (const [key, nurseryObject] of nurseryMap.markerMap.entries()) {
            if (resultKeyList.indexOf(key) === -1) {
                nurseryObject["pin"].setMap(null);
                nurseryMap.markerMap.delete(key);
            }
        }

        // ソート順を変更する。
        // 基本ID順で一覧を表示する。ただ、googlemap上では、後ろにピンが配置された場合
        // 後ろに配置されたピン優先される。ピン配置のときだけ、一覧を大きい順に変更する。
        // また、jsonのオブジェクトのキーはキーであり順序は考慮されない仕様。jsonデコード
        // した時点で情報は崩れる。そのため、別途キーの一覧を生成大きい順にソート。それをループしてピンを配置する。
        //const keyList = Object.keys(nurseryMap.markerDataList);
        // keyList.sort().reverse();

        // マーカー設置
        for (const [key, nurseryObject] of nurseryMap.markerMap.entries()) {
            if (nurseryObject["pin"] === undefined) {
                const markerLatLng = new google.maps.LatLng({
                    lat: nurseryObject["lat"],
                    lng: nurseryObject["lng"]
                });

                const iconObject = {
                    url: nurseryObject["mapPinImage"], // url
                    scaledSize: nurseryObject["isRecommended"]
                        ? new google.maps.Size(50, 50 * 1.17) // オススメピンの画像の縦横比がおよそ 1:1.17 であることから縦の大きさを計算している
                        : new google.maps.Size(25, 34), // scaled size
                    origin: new google.maps.Point(0, 0), // origin
                    anchor: new google.maps.Point(12, 0) // anchor
                };

                const iconClickObject = {
                    url: nurseryObject["mapClickPinImage"], // url
                    scaledSize: nurseryObject["isRecommended"]
                        ? new google.maps.Size(72, 72 * 1.17) // オススメピンの画像の縦横比がおよそ 1:1.17 であることから縦の大きさを計算している
                        : new google.maps.Size(50, 63), // scaled size
                    origin: new google.maps.Point(0, 0), // origin
                    anchor: new google.maps.Point(25, 32) // anchor
                };

                nurseryObject["iconObject"] = iconObject;
                nurseryObject["iconClickObject"] = iconClickObject;
                nurseryObject["pin"] = new google.maps.Marker({
                    position: markerLatLng, // マーカーを立てる位置を指定
                    map: nurseryMap.map, // マーカーを立てる地図を指定
                    icon: nurseryObject["iconObject"] // イメージ
                });

                // クリック時の挙動を設定
                nurseryMap.markerEvent(key);
            }
        }

        // 移動後のクリックは一回だけ。
        nurseryMap.geocodeResult = null;

        // 距離の更新
        nurseryMap.updateDistance();

        // 左右のボタンのイベント登録
        nurseryMap.navEvent();

        nurseryMap.isLoading = false;
    },
    // 現在位置から現在表示中の保育施設までの距離の更新
    updateDistance: function () {
        const latitudeTo = $(".js-nursery-value-distance").data("latitude");
        const longitudeTo = $(".js-nursery-value-distance").data("longitude");

        const getDistance = distance.getDistance(latitudeTo, longitudeTo);
        $(".js-nursery-value-distance").html(getDistance);
    },
    // マーカークリック時の挙動
    markerEvent: function (i) {
        nurseryMap.markerMap.get(i)["pin"].addListener("click", function () {
            if (nurseryMap.isLoading) {
                return;
            }
            nurseryMap.isLoading = true;

            // マーカーをもとに戻して、選択中のマーカーに変更
            for (const nurseryObject of nurseryMap.markerMap.values()) {
                nurseryObject["pin"].setIcon(nurseryObject["iconObject"]);
                nurseryObject["pin"].setAnimation(null);
            }
            nurseryMap.markerMap.get(i)["pin"].setIcon(nurseryMap.markerMap.get(i)["iconClickObject"]);

            // バウンスアニメーションを追加。回数指定して止めるとかできないので時間で制御
            nurseryMap.markerMap.get(i)["pin"].setAnimation(google.maps.Animation.BOUNCE);
            setTimeout(() => {
                nurseryMap.markerMap.get(i)["pin"].setAnimation(null);
            }, 3000);

            // センターに移動
            nurseryMap.map.panTo(
                new google.maps.LatLng(nurseryMap.markerMap.get(i).lat, nurseryMap.markerMap.get(i).lng)
            );

            // パンする位置を少し上にずらす。縦幅の狭いスマホで見たときにアイコンが隠れるため。
            nurseryMap.map.panBy(0, 80);

            const paramList = new FormData();
            paramList.append("nurseryId", nurseryMap.markerMap.get(i)["nurseryId"]);

            // AJAXで対象の保育施設のデータを取得
            post.postAjaxData("/parent/ajaxMap/pickup", paramList, "", nurseryMap.pickupDone, null, null);
        });
    },
    navEvent: function () {
        if ($(".js-nursery-pickup").css("display") === "block") {
            const nurseryId = $(".js-nurseryId").val();
            const keyList = Array.from(nurseryMap.markerMap.keys());
            const currentIndex = keyList.indexOf(Number(nurseryId));
            if (currentIndex !== 0) {
                $("#js-nav-prev").show();
            }
            if (!(currentIndex === keyList.length - 1)) {
                $("#js-nav-next").show();
            }
            const prev = document.getElementById("js-nav-prev");
            prev.addEventListener("click", function () {
                const prevNurseryId = keyList[currentIndex - 1];
                google.maps.event.trigger(nurseryMap.markerMap.get(prevNurseryId)["pin"], "click");
                $("#js-nav-prev").hide();
                $("#js-nav-next").hide();
            });
            const next = document.getElementById("js-nav-next");
            next.addEventListener("click", function () {
                const nextNurseryId = keyList[currentIndex + 1];
                google.maps.event.trigger(nurseryMap.markerMap.get(nextNurseryId)["pin"], "click");
                $("#js-nav-prev").hide();
                $("#js-nav-next").hide();
            });
        }
    },
    // マーカークリック完了時の挙動
    pickupDone: function (results) {
        nurseryMap.isPickupNursery = true;

        // 値を挿入
        $(".js-nursery-pickup").html(results["template"]).show();

        // 位置を更新
        nurseryMap.updateDistance();

        modalWindow.enableButton();

        // お気に入りボタンを押したとき挙動
        $(".js-favorite-nursery").unbind();
        $(".js-favorite-nursery").click(function (e) {
            favorite.toggle(e.target.getAttribute("data-nursery_id"));
        });

        // 削除はいボタンを押したとき
        $(".js-confirm").unbind();
        $(".js-confirm").on("click", function () {
            const favoriteBtn = document.querySelector(".js-favorite-nursery");

            favorite.toggle(favoriteBtn.getAttribute("data-nursery_id"), "キープを削除しました");

            modalWindow.hideModal("#js-modal-dialog");
        });

        $(".js-memo-modal-hide").on("click", function () {
            modalWindow.hideModal("#js-modal-dialog");
        });
        //キーワード検索後の初期表示に矢印を表示させる
        if ($("#search").val() !== "") {
            nurseryMap.navEvent();
        }
    },
    // 住所から緯度経度生成
    codeAddress: function (keyword) {
        const paramList = new FormData();
        paramList.append("keyword", keyword);

        const center = nurseryMap.map.getCenter();
        paramList.append("latitude", center.lat());
        paramList.append("longitude", center.lng());

        post.postAjaxData(
            "/parent/ajaxMap/getCenterLocation",
            paramList,
            "",
            function ({ results }) {
                if (results && results.length !== 0) {
                    nurseryMap.geocodeLatitude = results[0].geometry.location.lat;
                    nurseryMap.geocodeLongitude = results[0].geometry.location.lng;

                    // 結果を保持する。
                    nurseryMap.geocodeResult = results[0];

                    // 初期化後は中心移動
                    nurseryMap.map.panTo(results[0].geometry.location);
                    $("#map").show();
                } else {
                    nurseryMap.codeAddressFromGeocode(keyword);
                }
            },
            (error) => {},
            null
        );
    },
    codeAddressFromGeocode(address) {
        const paramList = new FormData();
        paramList.append("address", address);

        post.postAjaxData(
            "/searchGeocode",
            paramList,
            "",
            function ({ results }) {
                if (results && results.length !== 0) {
                    // google.maps.Map()コンストラクタに定義されているsetCenter()メソッドで
                    // 変換した緯度・経度情報を地図の中心に表示
                    nurseryMap.geocodeLatitude = results[0].geometry.location.lat;
                    nurseryMap.geocodeLongitude = results[0].geometry.location.lng;

                    //結果を保持する。
                    nurseryMap.geocodeResult = results[0];

                    // 初期化後は中心移動
                    nurseryMap.map.panTo(results[0].geometry.location);
                } else {
                    // ジオコーディングが成功しなかった場合
                    toastr.options = {
                        closeButton: false,
                        debug: false,
                        newestOnTop: false,
                        progressBar: false,
                        positionClass: "toast-bottom-full-width",
                        preventDuplicates: false,
                        onclick: null,
                        showDuration: "300",
                        hideDuration: "1000",
                        timeOut: "5000",
                        extendedTimeOut: "1000",
                        showEasing: "swing",
                        hideEasing: "linear",
                        showMethod: "fadeIn",
                        hideMethod: "fadeOut"
                    };
                    toastr.error("検索結果が見つかりませんでした");
                }
            },
            (error) => {},
            () => {
                $("#map").show();
            }
        );
    },
    // バナー表示
    displayBanner(url, img) {
        const banner = document.getElementById("js-nursery-banner");
        banner.style.display = "block";
        banner.querySelector("a").href = url;
        banner.querySelector("img").src = img;
        nurseryMap.isBannerDisplayed = true;
    },
    // マップ中心がエリア内か判定
    isPointInside(polygon) {
        const centerPosition = nurseryMap.map.getCenter();
        const targetLat = centerPosition.lat(); //マップ中心の緯度
        const targetLon = centerPosition.lng(); //マップ中心の経度

        /**
         * レイキャスティングアルゴリズムによる判定
         *
         * @param point 判定地点の緯度経度
         * @param polygon 多角形の各頂点を表す緯度経度リスト
         * @returns {boolean} point が polygon 内に位置している場合に True を返す
         */
        const isPointInsidePolygon = (point, polygon) => {
            const [x, y] = point;
            let inside = false;

            // 多角形の各辺をループ処理（i = 現在の頂点, j = 前の頂点）
            for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
                const [xi, yi] = polygon[i]; // 現在の頂点の座標を xi, yi として取得
                const [xj, yj] = polygon[j]; // 前の頂点の座標を xj, yj として取得
                let intersect = false;
                // 辺が点のY座標を横切るかどうか判定
                if (yi > y !== yj > y) {
                    // 点のX座標が辺と交差するかどうかを計算
                    intersect = x < ((xj - xi) * (y - yi)) / (yj - yi) + xi;
                }
                // 交差した場合、inside を反転
                if (intersect) inside = !inside;
            }
            return inside;
        };

        // 判定したい点（マップの中心地点）の緯度経度
        const point = [targetLat, targetLon];

        return isPointInsidePolygon(point, polygon);
    }
};
window.nurseryMap = nurseryMap;

$(document).ready(function (e) {
    if ($(".js-map-page").length === 0) {
        return;
    }

    // 現在位置を押した
    $(".button-small--home").click(function () {
        // ログイン情報エリアが存在するか確認。存在しなければログイン画面を表示する。
        if ($(".js-parentUserInfo").length === 0) {
            modalWindow.showModal("#js-modal-regist-guide");
        } else if (
            $(".js-parentUserInfo").data("latitude") === "" ||
            $(".js-parentUserInfo").data("longitude") === ""
        ) {
            // 情報はあるのに、自宅が設定されていない。
            modalWindow.showModal("#js-modal-regist-home");
        } else {
            distance.setHome();

            // 移動
            nurseryMap.map.panTo(new google.maps.LatLng(distance.referenceLatitude, distance.referenceLongitude));
        }
    });
    // 現在位置を押した
    $(".button-small--current-location").click(function () {
        distance.setGps();

        // 移動
        nurseryMap.map.panTo(new google.maps.LatLng(distance.referenceLatitude, distance.referenceLongitude));
    });

    //キーワードを検索した
    $(".js-search").click(function () {
        const address = $("#search").val();
        nurseryMap.codeAddress(address);
    });

    // エンターキーの初期化
    $("#search").keypress(function (e) {
        if (e.keyCode === 13) {
            $(".js-search").trigger("click");
            return false;
        }
    });

    // 「認可」チェックボックスの処理
    eventHandler.handleCheckboxChangeInteractions(".js-licensed-nursery-parent", ".js-licensed-nursery-child");
    // 「認可外」チェックボックスの処理
    eventHandler.handleCheckboxChangeInteractions(".js-unlicensed-nursery-parent", ".js-unlicensed-nursery-child");

    // 検索開始ボタンを押した
    $(".js-search-condition").click(function () {
        nurseryMap.mapLoading();
        $(".js-modal-hide").trigger("click");
    });

    // 検索クリアボタンを押した
    $(".js-clear").click(function () {
        // 条件を全消し
        $("#js-modal-condition").find("[type=checkbox]").prop("checked", false);

        // ラジオを所定位置
        $("#js-modal-condition").find("[name=distance]:last").prop("checked", true);

        // 登園/お迎え時間 を「指定なし」に戻す
        $("#js-modal-condition").find("select[name=startTime]").val("");
        $("#js-modal-condition").find("select[name=endTime]").val("");
    });

    // バナーの×ボタンを押した
    $(".close-btn").click(function () {
        const banner = document.getElementById("js-nursery-banner");
        banner.style.display = "none";
    });

    // リスト表示
    $(".js-list-href").click(function () {
        const centerPosition = nurseryMap.map.getCenter();
        const centerLatitude = centerPosition.lat();
        const centerLongitude = centerPosition.lng();

        let gpsOnFlg = "";
        if (distance.distanceMode === "current") {
            gpsOnFlg = true;
        }

        const paramString = searchCondition.getSearchParamListWithKeyword(centerLatitude, centerLongitude, gpsOnFlg);
        window.location.href = "/search/" + paramString;
    });
});
